// extracted by mini-css-extract-plugin
export default {"container":"lj-z","blurb":"mj-z","links":"nj-z"};